import {alertValidation} from "../util/alertValidation";

export const exhibitionInfoValidation = (exhibitionRoom, type, imageFile) => {
    let result;
    if (imageFile === null) {
        alertValidation("이미지를 등록해주세요.");
        result = false;
    } else {
        result = true;
    }
    if (type === "kor") {
        // eslint-disable-next-line default-case
        switch (null) {
            case exhibitionRoom.commentator.id :
                alertValidation("일반 해설자를 입력해주세요.");
                result = false;
                break;
            case exhibitionRoom.commentatorForKid.id :
                alertValidation("어린이 해설자를 입력해주세요.");
                result = false;
                break;
            case exhibitionRoom.commentatorForBlind.id :
                alertValidation("시각장애인 해설자를 입력해주세요.");
                result = false;
                break;
        }
    } else if (type === "eng") {
        // eslint-disable-next-line default-case
        switch (null) {
            case exhibitionRoom.parentId :
                alertValidation("연관 데이터를 입력해주세요.");
                result = false;
                break;
            case exhibitionRoom.commentator.id :
                alertValidation("영어 해설자를 입력해주세요.");
                result = false;
                break;
        }
    }
    // eslint-disable-next-line default-case
    switch ("") {
        case exhibitionRoom.roomNo :
            alertValidation("전시관 이름을 입력해주세요.");
            result = false;
            break;
        case exhibitionRoom.name :
            alertValidation("콘텐츠 이름을 입력해주세요.");
            result = false;
            break;
        case exhibitionRoom.introduction :
            alertValidation("콘텐츠 소개를 입력해주세요.");
            result = false;
            break;
        case exhibitionRoom.imageAltText :
            alertValidation("이미지 대체문구를 입력해주세요.");
            result = false;
            break;
    }
    return result;
}